import React from "react";
import { Link } from "react-router-dom";
import { Film, MoreVertical } from "lucide-react";

const DirectorActiveRolesList = ({ dashboardData, navigate }) => {
  return (
    <div className="dd-card dd-roles-card">
      <div className="dd-card-header">
        <h2>My Active Roles</h2>
        <Link to="/dashboard/roles" className="dd-link-btn">View All</Link>
      </div>
      <div className="dd-roles-list">
        {dashboardData?.activeRoles?.map((role) => (
          <div className="dd-role-item" key={role.id}>
            <div className="dd-role-info">
              <div className="dd-role-icon-small"><Film size={16} /></div>
              <div>
                <h4 className="dd-role-title">{role.title}</h4>
                <p className="dd-role-project">{role.project}</p>
              </div>
            </div>
            <div className="dd-role-stats">
              <div className="dd-applicant-count">
                <strong>{role.applicants}</strong>
                <span>Applicants</span>
              </div>
              <button 
                className="dd-icon-btn" 
                title="Edit Role"
                onClick={() => navigate(`/dashboard/post-roles/${role.id}`)}
              >
                <MoreVertical size={16} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DirectorActiveRolesList;
